import { render, staticRenderFns } from "./KAutocomplete.vue?vue&type=template&id=06f15da2"
import script from "./KAutocomplete.vue?vue&type=script&lang=js"
export * from "./KAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./KAutocomplete.vue?vue&type=style&index=0&id=06f15da2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
